import { forwardRef } from "react";
import { SystemFieldType, SystemPageType } from "../../../../Model/SystemModels";
import { CardField } from "../../../Common/Template/Card/CardField";
import { CardGroup } from "../../../Common/Template/Card/CardGroup";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";

export const AdminAISearchIndexCard = forwardRef<PageContainerBase, React.PropsWithChildren<{}>>((props, ref) => {
    return (
        <PageContainer pageType={SystemPageType.Card} title="Scheda indice di ricerca AI" endpoint="odata/ai/search/index" ref={ref}>
            <CardGroup name="general" label="Generale" isOpen={true}>
                <CardField name="name" label="Nome" type={SystemFieldType.String} />
                <CardField name="description" label="Descrizione" type={SystemFieldType.String} />
                <CardField name="endpoint" label="Endpoint" type={SystemFieldType.String} />
                <CardField name="primaryAdminKey" label="Chiave admin primaria" type={SystemFieldType.String} />
                <CardField name="documentType" label="Tipo documento" type={SystemFieldType.Option} cmbOptions={[
                    {key: 0, text: "So Smart"},
                    {key: 10, text: "EOS Apps"}
                ]} />
                <CardField name="queryType" label="Tipo query" type={SystemFieldType.Option} cmbOptions={[
                    {key: 0, text: "Simple"},
                    {key: 10, text: "Semantic"},
                    {key: 20, text: "Vector"},
                    {key: 30, text: "Vector Simple Hybrid"},
                    {key: 40, text: "Vector Semantic Hybrid"}
                ]} />
                <CardField name="semanticConfiguration" label="Configurazione semantica" type={SystemFieldType.String} />
            </CardGroup>
        </PageContainer>
    );
});

